<template>
  <div class="row">
    <div class="col-12 col-xxl-6">
      <stock-rotations-form
        :init-product="queryProduct"
        @stockRotationsCreated="stockRotationsCreated"
        @instancesCreated="fetchLatestStockRotations(true)"
      />
    </div>
    <div class="col-12 col-xxl-6">
      <card>
        <div v-if="sidebarType === 'rotations'">
          <h4 class="card-title">Letzten Lagerbewegungen</h4>
          <table class="table table-striped table-bordered" style="margin-top: 0.75em;">
            <thead>
              <tr>
                <th>Datum</th>
                <th>Produkt</th>
                <th>Preis</th>
                <th v-if="warehouses.length > 1">Lager</th>
                <th>Grund</th>
                <th>User</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr is="StockRotationRow"
                v-for="lastStockRotation in last20StockRotations"
                :key="lastStockRotation.id"
                :stock-rotation="lastStockRotation"
                :accumulated="false"
                :show-warehouse="warehouses.length > 1"
                :hide-kostenstelle="true"
                @deleteStockRotation="deleteStockRotation"
              />
            </tbody>
          </table>
          <l-pagination
            background
            layout="prev, pager, next"
            :per-page="20"
            :page-count="pageCount"
            :value="currentPage"
            :show-per-page="false"
            @input="changePage"
          />
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Pagination as LPagination } from 'src/components'
import StockRotationsForm from 'src/pages/StockRotations/stock-rotations-form'
import StockRotationRow from 'src/pages/StockRotations/stock-rotation-row'
import { Tabs, TabPane } from 'element-ui'

export default {
  components: {
    LPagination,
    StockRotationsForm,
    StockRotationRow,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  data () {
    return {
      sidebarType: 'rotations',
      warehouses: [],
      productsToOrder: [],
      lastStockRotations: [],
      queryProduct: null,
      currentPage: 1,
      pageCount: null
    }
  },
  methods: {
    async deleteStockRotation (stockRotation) {
      if (confirm('Lagerbewegung wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/stock_rotations/${stockRotation.id}`).then(({ data }) => {
          this.$notify({
            message: `Lagerbewegung erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.lastStockRotations.findIndex(({ id }) => data.id === id)
          this.lastStockRotations.splice(index, 1)
        })
      }
    },
    stockRotationsCreated (...stockRotations) {
      this.lastStockRotations.unshift(...stockRotations)
    },
    fetchLatestStockRotations (resetPage = false) {
      const queryData = {
        paginate: 1,
        page: resetPage ? 1 : this.currentPage,
        per_page: 20
      }
      const query = new URLSearchParams(queryData).toString()
      return this.$http.get(`/stock_rotations?${query}`).then(({ data }) => {
        this.lastStockRotations = data.data
        this.pageCount = data.last_page
      })
    },
    changePage (page) {
      this.currentPage = page
      this.fetchLatestStockRotations()
    }
  },
  computed: {
    last20StockRotations () {
      if (this.lastStockRotations.length > 20) {
        return this.lastStockRotations.slice(0, 20)
      }
      return this.lastStockRotations
    }
  },
  created () {
    if (this.$route.query['product']) {
      this.$http.get(`/products/${this.$route.query['product']}`).then(({ data }) => {
        this.queryProduct = data
      })
    }
    this.$http.get(`/warehouses`).then(({ data }) => {
      this.warehouses = data
    })
    this.fetchLatestStockRotations()
  }
}
</script>

<style>
  .form-check-inline {
    vertical-align: sub;
  }
</style>
